import React from "react";
import selectFormat from "../selectFormat";
import { useDispatch, useSelector } from "react-redux";
import metricDefinitions from "../../metricDefinitions";
import moment from "moment";

export default function PostGeneralMetrics(props) {
  const { organization_name, permissions } = useSelector(
    (state) => state.static
  );
  const dispatch = useDispatch()
  let metrics = metricDefinitions(organization_name, permissions)[
    "post general"
  ].metrics;

  React.useEffect(() => {
    dispatch({
      type: "UPDATE_DATES_FILTERS",
      payload: {
        start_date: moment().subtract('2', 'weeks').format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        
      },
    })
  }, []);

  return (
    <div className="col-12 align-items-center">
      {metrics
        .filter((metric) => metric.visible == true)
        .map((metric, index) => {
          if (metric.is_fake) {
            if (
              organization_name == "sober-homes" ||
              organization_name == "treatment-center"
            ) {
              return selectFormat(metric, index, props);
            }
          } else {
            return selectFormat(metric, index, props);
          }
        })}
      <div className="py-3" />
    </div>
  );
}
